// extracted by mini-css-extract-plugin
export default {"bgColorWarning":"#ff877f","whiteColor":"#fff","copyLinkBtn":"CopyLinkButton_copyLinkBtn__XGrp3"};